// El servidor de acceso responde con un `code` en cada error; aqui se traduce a la clave
// de lang.json. Los mensajes del servidor (`message`) estan solo en español.
const AUTH_ERROR_KEYS = {
  invalid_email: 'auth_error_email_invalid',
  password_too_short: 'auth_error_password_short',
  email_taken: 'auth_error_email_taken',
  invalid_credentials: 'auth_error_invalid_credentials',
  invalid_code: 'auth_error_invalid_code',
  send_failed: 'auth_error_send_code',
  too_many_attempts: 'auth_error_too_many'
};

export const authErrorKey = (code, fallback) => AUTH_ERROR_KEYS[code] || fallback;
